module.exports = __webpack_public_path__ + "img/image148.12d7cfe5.jpg";